var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.928 7.51-.006-.025a7.07 7.07 0 0 0-2.476-3.917l-.005-.007c-.004-.003-.009-.003-.012-.006a7.043 7.043 0 0 0-4.01-1.504l.329-.327a1.009 1.009 0 0 0 0-1.428 1.012 1.012 0 0 0-1.43 0L6.296 2.313a1.01 1.01 0 0 0 0 1.428l2.022 2.018c.197.197.456.296.715.296a1.008 1.008 0 0 0 .715-1.723l-.255-.256a5.05 5.05 0 0 1 4.464 3.87v.008c.08.337.323.589.627.705.114.044.236.071.364.071.071 0 .152 0 .221-.02.542-.13.884-.658.76-1.2Z"
  })));
};
export default SvgRotate;